<flagg [land]="lokaleSomLokaleinformasjon().region" hoyde="12"/>
@if(stil() == 'flaggOgTekst'){
  <span class="språk" data-testid="språk">{{lokaleSomBrukerrettetStreng()}}</span>
}
